<template>
  <div class="how-it-works">
    <div class="container">
      <h2 class="section-header how-it-works__header">
        How It Works
      </h2>
      <div class="how-it-works__grid">
        <div v-for="card of cards" :key="card.title" class="how-it-works__card">
          <img
            v-lazy="card.img.src"
            :alt="card.img.alt"
            class="how-it-works__image"
          >
          <h3 class="how-it-works__card-title">
            {{ card.title }}
          </h3>
          <p class="how-it-works__card-content">
            {{ card.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowItWorks',
  data () {
    return {
      cards: [
        {
          img: {
            src: require('@/assets/images/usage.svg'),
            alt: 'Conversation bubbles illustration'
          },
          title: 'Tell us about your needs',
          content: 'We’ll ask you some quick and easy questions online to work out exactly what you need.'
        },
        {
          img: {
            src: require('@/assets/images/choose.svg'),
            alt: 'Product selection illustration'
          },
          title: 'Our experts help choose the right products',
          content: 'We’ll help choose the right business broadband and phone line products on a quick call.'
        },
        {
          img: {
            src: require('@/assets/images/takecare.svg'),
            alt: 'Happy customer relaxing illustration'
          },
          title: 'We\'ll take care of the rest',
          content: "You choose the deal you want and we take care of the rest. We'll keep you updated, every step of the way."
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.how-it-works {
  background-color: $how-it-works-bg;
  padding: $spacing-40 $spacing-0;

  &__header {
    font-size: 32px;
    text-align: center;

    @media (max-width: $screen-md) {
      font-size: 30px;
    }
  }

  &__grid {
    display: flex;
    flex-direction: column;
  }

  &__card {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: $spacing-20;

    &:last-child {
      margin-bottom: $spacing-0;
    }
  }

  &__card-title {
    margin: $spacing-24 $spacing-0 $spacing-8;
    font-size: 24px;
    line-height: 29px;
    text-align: center;

    @media (max-width: $screen-md) {
      font-size: 20px;
      line-height: 26px;
    }
  }

  &__card-content {
    font-size: 18px;
    line-height: 22px;

    @media (max-width: $screen-md) {
      font-size: 16px;
      line-height: 18px;
    }
  }

  &__image {
    height: 100px;
    width: 100%;
  }

  @media (min-width: $screen-md) {
    &__header {
      font-size: 30px;
    }

    &__grid {
      flex-direction: row;
      justify-content: space-between;
    }

    &__card {
      width: 32%;
      margin-bottom: $spacing-0;
    }

    &__image {
      height: 170px;
    }
  }
}
</style>
